import { isDefined, isNotDefined } from '@sgme/fp';

import { initiateDateFromTenor } from '@/api/dates/index.ts';
import type { Client } from '@/api/user/getCurrentUser.ts';
import type { AppDispatch } from '@/store/store.ts';

export async function getMaxDate(
  clientId: number,
  currentUserCache: Client[] | undefined,
  dispatch: AppDispatch,
  currencyPair?: string,
): Promise<string | undefined> {
  if (isNotDefined(currencyPair)) {
    return undefined;
  }

  const maxTenor = currentUserCache?.find((client) => client.companyId === clientId)?.maxTenor;

  if (isNotDefined(maxTenor)) {
    return undefined;
  }

  const { data: maxDate } = await dispatch(initiateDateFromTenor({ tenor: maxTenor, currencyPair }));
  if (isDefined(maxDate)) {
    return maxDate;
  }

  return undefined;
}
